import { createSlice } from '@reduxjs/toolkit';

interface State {
  prevRoute: string;
  listRoute: string;
}

const initialState: State = {
  prevRoute: '',
  listRoute: '',
};

const appRouteSlice = createSlice({
  name: 'appRoute',
  initialState,
  reducers: {
    saveRoute: (state, action) => {
      state.prevRoute = action.payload;
    },
    saveListRoute: (state, action) => {
      state.listRoute = action.payload;
    },
    clearPrevRoute: state => {
      state.prevRoute = '';
    },
  },
  extraReducers: {},
});

const { reducer: appRouteReducer } = appRouteSlice;

export const { saveRoute, clearPrevRoute } = appRouteSlice.actions;
export default appRouteReducer;
